import { render } from "./GenericChart.vue?vue&type=template&id=74e23ab3&ts=true"
import script from "./GenericChart.vue?vue&type=script&lang=ts"
export * from "./GenericChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__